import { render, staticRenderFns } from "./attributeBasedSettings.vue?vue&type=template&id=3d288201&scoped=true"
import script from "./attributeBasedSettings.vue?vue&type=script&lang=js"
export * from "./attributeBasedSettings.vue?vue&type=script&lang=js"
import style0 from "./attributeBasedSettings.vue?vue&type=style&index=0&id=3d288201&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d288201",
  null
  
)

export default component.exports